export default "__VITE_ASSET__B1J9iydo__"